import { z } from 'zod';
import {
  dateRangeSchema,
  paginationFiltersSchema,
  sortFiltersSchema,
} from 'utils/schemas';
import { transmissionActListVariants } from './transmission-acts.types';

export const transmissionActsFiltersSchema = z
  .object({
    company: z.string().catch(''),
    date: dateRangeSchema,
    listVariant: z.enum(transmissionActListVariants).catch('reports'),
  })
  .merge(paginationFiltersSchema)
  .merge(sortFiltersSchema);

export const transactionsFiltersSchema = z.object({
  company: z.string().catch(''),
  date: dateRangeSchema,
  listVariant: z.enum(transmissionActListVariants).catch('reports'),
});
